import { useEffect } from 'react';

const emptySet = new Set();
export const useKeepExistingIds = ({
  propsRef,
  index,
  loading,
  ids = emptySet,
  onChange,
}) => {
  useEffect(() => {
    const currentIds = propsRef.current.value?.[index];

    if (!loading && currentIds?.length) {
      const newIds = currentIds.filter((id) => ids.has(id));
      onChange(newIds);
    }
  }, [propsRef, index, loading, ids, onChange]);
};
